import { useEffect, useState } from 'react'
import api from '../services/api'

interface CampoExtra { campo: string; label: string; tamanho: number }

// Largura do campo proporcional ao limite de caracteres (evita caixa maior do que o texto que cabe nela).
function larguraPorCaracteres(tamanho: number) {
  return Math.max(90, tamanho * 9 + 30)
}

function TabCadastroSimples({ apiPath, colCod, colDes, tamCod, tamDes, labelCod, labelDes, tituloLista, campoExtra }: {
  apiPath: string; colCod: string; colDes: string; tamCod: number; tamDes: number
  labelCod: string; labelDes: string; tituloLista: string; campoExtra?: CampoExtra
}) {
  const [lista, setLista] = useState<Record<string, string>[]>([])
  const [busca, setBusca] = useState('')
  const [carregandoLista, setCarregandoLista] = useState(false)
  const [selecionado, setSelecionado] = useState<Record<string, string> | null>(null)
  const [carregandoDetalhe, setCarregandoDetalhe] = useState(false)
  const [modoNovo, setModoNovo] = useState(false)
  const [codigoNovo, setCodigoNovo] = useState('')
  const [descricao, setDescricao] = useState('')
  const [extra, setExtra] = useState('')
  const [salvando, setSalvando] = useState(false)
  const [msgSalvar, setMsgSalvar] = useState('')

  async function carregarLista(termo: string) {
    setCarregandoLista(true)
    try {
      const r = await api.get(`/tributacoes/${apiPath}`, { params: termo ? { busca: termo } : {} })
      setLista(r.data)
    } finally {
      setCarregandoLista(false)
    }
  }

  useEffect(() => { carregarLista('') }, []) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const t = setTimeout(() => carregarLista(busca), 350)
    return () => clearTimeout(t)
  }, [busca]) // eslint-disable-line react-hooks/exhaustive-deps

  function novo() {
    setModoNovo(true)
    setSelecionado(null)
    setMsgSalvar('')
    setCodigoNovo('')
    setDescricao('')
    setExtra('')
  }

  async function selecionar(cod: string) {
    setModoNovo(false)
    setCarregandoDetalhe(true)
    setMsgSalvar('')
    try {
      const r = await api.get(`/tributacoes/${apiPath}/${cod}`)
      setSelecionado(r.data)
      setDescricao(r.data[colDes] ?? '')
      if (campoExtra) setExtra(r.data[campoExtra.campo] ?? '')
    } finally {
      setCarregandoDetalhe(false)
    }
  }

  async function salvar() {
    if (modoNovo) {
      if (!codigoNovo.trim()) { setMsgSalvar('Informe o código.'); return }
      setSalvando(true)
      setMsgSalvar('')
      try {
        const body: Record<string, string> = { [colCod]: codigoNovo.trim(), [colDes]: descricao }
        if (campoExtra) body[campoExtra.campo] = extra
        await api.post(`/tributacoes/${apiPath}`, body)
        await carregarLista(busca)
        const cod = codigoNovo.trim()
        setModoNovo(false)
        await selecionar(cod)
        setMsgSalvar('Código cadastrado com sucesso.')
      } catch (e: any) {
        setMsgSalvar(e.response?.data?.error ?? 'Erro ao cadastrar.')
      } finally {
        setSalvando(false)
      }
      return
    }

    if (!selecionado) return
    setSalvando(true)
    setMsgSalvar('')
    try {
      const body: Record<string, string> = { [colDes]: descricao }
      if (campoExtra) body[campoExtra.campo] = extra
      await api.put(`/tributacoes/${apiPath}/${selecionado[colCod]}`, body)
      setMsgSalvar('Alterações salvas com sucesso.')
      await carregarLista(busca)
    } catch (e: any) {
      setMsgSalvar(e.response?.data?.error ?? 'Erro ao salvar.')
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start', marginTop: '1rem' }}>
      <div className="card" style={{ width: 340, flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
          <h3 style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1a6ea8' }}>{tituloLista}</h3>
          <button type="button" className="btn btn-primary btn-sm" onClick={novo}>+ Novo</button>
        </div>
        <div className="field" style={{ marginBottom: '0.75rem' }}>
          <input
            type="text"
            placeholder="Código ou descrição..."
            value={busca}
            onChange={e => setBusca(e.target.value)}
          />
        </div>

        {carregandoLista && <p style={{ color: '#6b7280', fontSize: '0.85rem' }}>Carregando...</p>}
        {!carregandoLista && lista.length === 0 && (
          <p style={{ color: '#6b7280', fontSize: '0.85rem' }}>Nenhum código encontrado.</p>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 560, overflowY: 'auto' }}>
          {lista.map(item => {
            const ativo = selecionado?.[colCod] === item[colCod]
            return (
              <button
                key={item[colCod]}
                onClick={() => selecionar(item[colCod])}
                style={{
                  textAlign: 'left', border: '1px solid #e5e7eb', borderRadius: 6, padding: '8px 10px', cursor: 'pointer',
                  background: ativo ? '#eff6ff' : '#f8fafc', borderColor: ativo ? '#1a6ea8' : '#e5e7eb',
                }}
              >
                <div style={{ fontWeight: 700, fontSize: '0.82rem', color: '#1a6ea8' }}>{item[colCod]}</div>
                <div style={{ fontSize: '0.8rem', color: '#374151', marginTop: 2 }}>{item[colDes]}</div>
              </button>
            )
          })}
        </div>
      </div>

      <div className="card" style={{ flex: 1, minWidth: 0 }}>
        {!selecionado && carregandoDetalhe && (
          <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Carregando detalhes...</p>
        )}
        {!selecionado && !carregandoDetalhe && !modoNovo && (
          <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>
            Selecione um código na lista ao lado, ou clique em "+ Novo".
          </p>
        )}

        {(selecionado || modoNovo) && (
          <>
            <h3 style={{
              fontSize: '1.05rem', fontWeight: 700, color: '#1a6ea8',
              marginBottom: '1rem', paddingBottom: '0.9rem', borderBottom: '2px solid #eff6ff',
            }}>
              {modoNovo ? 'Novo código' : selecionado?.[colCod]}
              {carregandoDetalhe && (
                <span style={{ marginLeft: 10, fontSize: '0.72rem', fontWeight: 500, color: '#9ca3af' }}>atualizando...</span>
              )}
            </h3>

            <div style={{
              background: '#f7faff', border: '1px solid #eef0f4', borderLeft: '4px solid #1a6ea8',
              borderRadius: '0.5rem', padding: '0.9rem 1.1rem', marginBottom: '0.9rem',
              display: 'flex', flexWrap: 'wrap', gap: '0.6rem 1rem', alignItems: 'flex-end',
            }}>
              <div className="field-cad" style={{ width: 120, flexShrink: 0 }}>
                <label>{labelCod}</label>
                {modoNovo ? (
                  <input type="text" maxLength={tamCod} value={codigoNovo} onChange={e => setCodigoNovo(e.target.value)} />
                ) : (
                  <input type="text" value={selecionado?.[colCod] ?? ''} readOnly disabled />
                )}
              </div>
              <div className="field-cad" style={{ flex: '1 1 auto', minWidth: larguraPorCaracteres(tamDes) }}>
                <label>{labelDes}</label>
                <input type="text" maxLength={tamDes} value={descricao} onChange={e => setDescricao(e.target.value)} style={{ width: '100%' }} />
              </div>
              {campoExtra && (
                <div className="field-cad" style={{ width: larguraPorCaracteres(campoExtra.tamanho), flexShrink: 0 }}>
                  <label>{campoExtra.label}</label>
                  <input type="text" maxLength={campoExtra.tamanho} value={extra} onChange={e => setExtra(e.target.value)} style={{ width: '100%' }} />
                </div>
              )}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <button className="btn btn-primary" onClick={salvar} disabled={salvando}>
                {salvando ? 'Salvando...' : modoNovo ? 'Cadastrar' : 'Salvar alterações'}
              </button>
              {msgSalvar && (
                <span style={{
                  fontSize: '0.8rem', fontWeight: 600, padding: '0.35rem 0.8rem', borderRadius: 6,
                  background: msgSalvar.includes('sucesso') ? '#d1fae5' : '#fee2e2',
                  color: msgSalvar.includes('sucesso') ? '#065f46' : '#991b1b',
                }}>
                  {msgSalvar}
                </span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

const TABS = [
  { key: 'icms',   label: 'CST ICMS',                       tabela: 'TTRICAD' },
  { key: 'ipi',    label: 'CST IPI',                         tabela: 'TTRIIPI' },
  { key: 'pis',    label: 'CST PIS',                         tabela: 'TTRIPIS' },
  { key: 'cofins', label: 'CST COFINS',                      tabela: 'TTRICOF' },
  { key: 'moddoc', label: 'Modelos de Documentos Fiscais',   tabela: 'TMODDOC' },
] as const

type TabKey = typeof TABS[number]['key']

export default function Tributacoes() {
  const [aba, setAba] = useState<TabKey>('icms')

  return (
    <div>
      <div className="card" style={{ marginBottom: '1rem' }}>
        <h3 style={{ fontSize: '1rem', fontWeight: 700, color: '#1a6ea8', marginBottom: '0.3rem' }}>
          Tributações
        </h3>
        <p style={{ fontSize: '0.82rem', color: '#6b7280' }}>
          Códigos de Situação Tributária (ICMS, IPI, PIS, COFINS) e Modelos de Documentos Fiscais.
        </p>
      </div>

      <div className="card">
        <div className="fiscal-tabs" style={{ flexWrap: 'wrap', display: 'flex', alignItems: 'center' }}>
          {TABS.map(t => (
            <button key={t.key} type="button"
              className={`fiscal-tab${aba === t.key ? ' fiscal-tab--ativa' : ''}`}
              onClick={() => setAba(t.key)}>
              {t.label}
            </button>
          ))}
          <span style={{ marginLeft: 'auto', fontSize: '0.78rem', fontWeight: 700, color: '#111827' }}>
            {TABS.find(t => t.key === aba)?.tabela}
          </span>
        </div>

        {aba === 'icms' && (
          <TabCadastroSimples apiPath="tricad" colCod="tri_cod" colDes="tri_des" tamCod={3} tamDes={80}
            labelCod="Código" labelDes="Descrição" tituloLista="CST ICMS" />
        )}
        {aba === 'ipi' && (
          <TabCadastroSimples apiPath="triipi" colCod="cstipi_cod" colDes="cstipi_des" tamCod={2} tamDes={80}
            labelCod="Código" labelDes="Descrição" tituloLista="CST IPI" />
        )}
        {aba === 'pis' && (
          <TabCadastroSimples apiPath="tripis" colCod="cstpis_cod" colDes="cstpis_des" tamCod={2} tamDes={80}
            labelCod="Código" labelDes="Descrição" tituloLista="CST PIS" />
        )}
        {aba === 'cofins' && (
          <TabCadastroSimples apiPath="tricof" colCod="cstcof_cod" colDes="cstcof_des" tamCod={2} tamDes={80}
            labelCod="Código" labelDes="Descrição" tituloLista="CST COFINS" />
        )}
        {aba === 'moddoc' && (
          <TabCadastroSimples apiPath="moddoc" colCod="moddoc_cod" colDes="moddoc_des" tamCod={2} tamDes={50}
            labelCod="Código" labelDes="Descrição" tituloLista="Modelos de Documentos Fiscais"
            campoExtra={{ campo: 'moddoc_dfe', label: 'DFe', tamanho: 5 }} />
        )}
      </div>
    </div>
  )
}
